import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ActionLink from "../../../../controls/ActionLink";
import TenderDocumentsModal from "../modals/TenderDocumentsModal";
import BackEnd from "../../../../backend/BackEnd";
import FileUploader from "../../../../components/FileUploader";

const $ = window.jQuery;

class Documents extends Component {
    static propTypes = {
        tenderId: PropTypes.number.isRequired
    };
    static defaultProps = {
        entityName: 'Tender',
        clientDocuments: 'ClientDocuments',
        supplierDocuments: 'SupplierDocuments'
    };
    state = {
        isLoading: false,
        showListModal: false,
        clientDocuments: [],
        supplierDocuments: []
    };
    maxSize = 30 * 1024 * 1024; // 30MB
    loadingSpinner = <i className="fa fa-circle-o-notch fa-spin"/>;
    getDocuments = new BackEnd.Documents.GetOrderDocuments({
        start: () => this.setState({isLoading: true}),
        end: () => this.setState({isLoading: false})
    });

    async componentDidMount() {
        await this.fetchDocuments();
    }

    render() {
        let documentCount = this.state.clientDocuments.length + this.state.supplierDocuments.length;
        let documentCountText = documentCount ? `(${documentCount})` : '';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12 clearfix">
                        {
                            this.state.isLoading
                                ? this.loadingSpinner
                                : (
                                    <span>
                                        <i className="fa fa-paperclip"/>&nbsp;
                                        <ActionLink onClick={() => this.showListModal()}>
                                            Показать документы {documentCountText}
                                        </ActionLink>
                                    </span>
                                )
                        }
                        <div className="pull-right">
                            <div className="btn-group">
                                <button type="button" className="btn btn-outline btn-xs dropdown-toggle m-r-1"
                                        data-toggle="dropdown">
                                    <i className="fa fa-upload"/> Прикрепить
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <ActionLink onClick={() => this.clientFileUploader.open()}>
                                            Для клиента
                                        </ActionLink>
                                    </li>
                                    <li>
                                        <ActionLink onClick={() => this.supplierFileUploader.open()}>
                                            Для поставщика
                                        </ActionLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="btn-group">
                                <button type="button" className="btn btn-outline btn-xs dropdown-toggle"
                                        data-toggle="dropdown">
                                    <i className="fa fa-cloud-download"/> Скачать
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <ActionLink onClick={() => this.downloadForClient()}>
                                            Для клиента
                                        </ActionLink>
                                    </li>
                                    <li>
                                        <ActionLink onClick={() => this.downloadForSupplier()}>
                                            Для поставщика
                                        </ActionLink>
                                    </li>
                                    {/*<li className="divider"/>*/}
                                    {/*<li>*/}
                                        {/*<ActionLink onClick={() => this.downloadAll()}>*/}
                                            {/*Все*/}
                                        {/*</ActionLink>*/}
                                    {/*</li>*/}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <FileUploader ref={el => this.clientFileUploader = el}
                              entityId={this.props.tenderId}
                              entityName="Tender"
                              propertyName="ClientDocuments"
                              onUpload={() => this.fetchDocuments()}/>
                <FileUploader ref={el => this.supplierFileUploader = el}
                              entityId={this.props.tenderId}
                              entityName="Tender"
                              propertyName="SupplierDocuments"
                              onUpload={() => this.fetchDocuments()}/>
                <TenderDocumentsModal tenderId={this.props.tenderId}
                                      clientDocuments={this.state.clientDocuments}
                                      supplierDocuments={this.state.supplierDocuments}
                                      onUpload={() => this.fetchDocuments()}
                                      show={this.state.showListModal}
                                      onHide={() => this.setState({showListModal: false})}/>
            </div>
        );
    }

    async fetchDocuments() {
        let clientDocuments = await this.getDocuments.call({
            entityId: this.props.tenderId,
            entityName: this.props.entityName,
            propertyName: this.props.clientDocuments
        });
        let supplierDocuments = await this.getDocuments.call({
            entityId: this.props.tenderId,
            entityName: this.props.entityName,
            propertyName: this.props.supplierDocuments
        });

        this.setState({
            clientDocuments,
            supplierDocuments
        });
    }

    showListModal() {
        this.setState({showListModal: true});
    }

    async downloadForClient() {
        await this.downloadAll('ClientDocuments');
    }

    async downloadForSupplier() {
        await this.downloadAll('SupplierDocuments');
    }

    async downloadAll(propertyName = null) {
        let getFileToken = new BackEnd.Tokens.GetFileToken();
        let token = await getFileToken.call();

        let downloadFilesPackage = new BackEnd.Documents.DownloadFilesPackage();
        let href = downloadFilesPackage.createUrl({
            entityId: this.props.tenderId,
            entityName: 'Tender',
            propertyName,
            token
        });

        $('<a />').attr({href, download: 'download'}).get(0).click();
    }
}

export default Documents;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/Tenders/components/Documents.js